import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  zh_tw: {
    "取消": '取消',
    "确定": '確定',
    "发送": '發送',
    "系统通知": '系統通知',
    "关闭": '關閉',
    "图片": '圖片',
    "文件": '文件',
    "表情": '表情',
    "视频": '視頻',
    "录制": '錄製',
    "拍照": '拍照',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;
